package net.frozenbit.games.soundgame.theme

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.unit.dp

object Shapes {
    object Host {
        val mediumContainer = RoundedCornerShape(16.dp)
    }
}
